var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapFlat = function SvgMapFlat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#44C868",
    d: "m22.317 20.856-1.622-8.936a.3.3 0 0 0-.15-.21l-4.083-2.271a.3.3 0 0 0-.17-.037l.742 9.581-.025.011 4.886 2.192a.3.3 0 0 0 .31-.038.3.3 0 0 0 .112-.292M12 11.61 7.823 9.435a.3.3 0 0 0-.117-.033l-.742 9.581 4.91 2.203q.06.027.124.027z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CE166",
    d: "M7.708 9.402a.3.3 0 0 0-.17.037l-4.083 2.27a.3.3 0 0 0-.151.21l-1.622 8.937a.303.303 0 0 0 .422.33l4.86-2.18zM16.292 9.401a.3.3 0 0 0-.117.033L12 11.61v9.603a.3.3 0 0 0 .124-.027l4.91-2.203z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB56",
    d: "m2.812 14.628-.33 1.815 4.88-2.577.113-1.46.019-.243z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8EEFC",
    d: "m7.406 13.3-.044.566-4.879 2.577-.8 4.413a.303.303 0 0 0 .421.33l4.86-2.18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB24",
    d: "m12 12.807-4.507-.644-.132 1.704L12 20.91v-2.561L9.232 13.99l2.769.331zM20.223 11.531l-1.961-1.09-1.857.433.023.3.092 1.183z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB56",
    d: "m16.685 14.48-.176-2.267-.104-1.34L12 12.808v1.515l2.878-1.251z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB24",
    d: "m22.317 20.858-.407-2.245-5.39-6.255.165 2.124 5.527 6.662a.3.3 0 0 0 .105-.286"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M12.019 2.784A4.24 4.24 0 0 0 7.78 7.019c0 1.445.686 2.996 2.039 4.61a14.5 14.5 0 0 0 2.015 1.98.3.3 0 0 0 .37 0 14.5 14.5 0 0 0 2.015-1.98c1.353-1.614 2.039-3.165 2.039-4.61a4.24 4.24 0 0 0-4.24-4.235m1.57 4.235a1.57 1.57 0 1 1-3.139-.001 1.57 1.57 0 0 1 3.139.001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7343F",
    d: "M12.019 2.784q-.278 0-.547.035a4.24 4.24 0 0 1 3.692 4.2c0 1.445-.686 2.996-2.038 4.61a15 15 0 0 1-1.654 1.68c.212.184.347.289.361.3a.3.3 0 0 0 .371 0 14.5 14.5 0 0 0 2.015-1.98c1.353-1.614 2.039-3.165 2.039-4.61a4.24 4.24 0 0 0-4.24-4.235"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB56",
    d: "m12.124 21.188 1.826-.82L12 18.35v2.864a.3.3 0 0 0 .124-.026"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EA4E9",
    d: "M20.695 11.923a.3.3 0 0 0-.15-.21l-.322-.179-3.702.826 5.389 6.255zM12 21.216v-.303L7.36 13.87l-.396 5.117 4.91 2.203q.06.026.124.026"
  })));
};
export default SvgMapFlat;